module.exports = __webpack_public_path__ + "media/images/forward_10_black_24dp-36098df8e5eb53da1b28234ac91b320e.svg";